// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"440":"f39e43b5","921":"7ae6408f"}[chunkId] || chunkId) + "." + {"440":"8d3464efe4bb522c","516":"83654e86a2e4df57","921":"e35091a2a0f58c57","948":"528181a4b0ea5875"}[chunkId] + ".js";
};